import { STATUSES } from '@openclassrooms/ui-web/learning-activities';

export const STATUS_PROMOTION = 'promotion';

const { STATUS_NOT_STARTED, STATUS_IN_PROGRESS, STATUS_CAN_RETRY, STATUS_FAILED, STATUS_PASSED } =
  STATUSES;

export const CHAPTER_STATUSES = [
  STATUS_PROMOTION,
  STATUS_NOT_STARTED,
  STATUS_IN_PROGRESS,
  STATUS_PASSED,
];

export const QUIZ_STATUSES = [
  STATUS_NOT_STARTED,
  STATUS_IN_PROGRESS,
  STATUS_CAN_RETRY,
  STATUS_FAILED,
  STATUS_PASSED,
  STATUS_PROMOTION,
];

export const QUIZ_COMPLETED_STATUSES = [STATUS_CAN_RETRY, STATUS_FAILED, STATUS_PASSED];
